export default "__VITE_ASSET__BinmgJZ$__"